import { createRef, Component } from 'react';
import styled from 'styled-components';
import { debounce } from 'underscore';

export default class AcademyThemeWrapper extends Component {
  constructor(props) {
    super(props);

    this.state = {
      fixFooter: false,
    };

    this.wrapperRef = createRef();
  }

  resizeObeserver = new ResizeObserver((entries) => {
    entries.forEach(() => {
      this.handleShortLayouts();
    });
  });

  componentDidMount() {
    this.resizeObeserver.observe(this.wrapperRef.current);
  }

  componentWillUnmount() {
    this.resizeObeserver.unobserve(this.wrapperRef.current);
  }

  handleShortLayouts = debounce(() => {
    this.setState({
      fixFooter: this.wrapperRef.current?.clientHeight < window.innerHeight,
    });
  }, 300);

  render() {
    const wrapperClasses = this.getWrapperClasses();
    const { backgroundImage, blurForArsh, children, minFullHeight, style } = this.props;

    return (
      <AcademyWrapper
        className={wrapperClasses.join(' ')}
        backgroundImage={backgroundImage}
        blurForArsh={blurForArsh}
        ref={this.wrapperRef}
        minFullHeight={minFullHeight}
        style={style || {}}
      >
        {children}
      </AcademyWrapper>
    );
  }

  getWrapperClasses = () => {
    const wrapperClasses = [];
    const { hasLogo } = this.props;
    const { fixFooter } = this.state;
    if (!hasLogo) wrapperClasses.push('no-custom-logo');
    if (getUrlParameters().prevent_default === 'true') wrapperClasses.push('prevent-interaction');
    if (fixFooter) wrapperClasses.push('fix-footer');

    return wrapperClasses;
  };
}

const AcademyWrapper = styled.div`
  position: relative;
  background-color: #fff;
  box-sizing: border-box;
  ${(props) =>
    props.backgroundImage &&
    `
    background: url(${props.backgroundImage}) center center no-repeat;
    background-size: cover;
  `}
  ${(props) => props.minFullHeight && 'min-height: 100vh;'}
  &.no-custom-logo {
  }
  &.prevent-interaction {
    &:after {
      content: '';
      display: block;
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 99999;
    }
  }
  &.fix-footer {
    .academy-footer {
      position: fixed;
      bottom: 0;
      left: 0;
      width: 100%;
    }
  }
  ${(props) => props.blurForArsh && 'filter: blur(1px);'}
`;
